<template>
  <v-card
    tile
    outlined
    class="w-100"
  >
    <v-card-title class="primary--text">
      {{ title }}
      <v-spacer />
      <v-btn
        icon
        @click="toggleExpand"
      >
        <v-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      Accounting reports only include data on completed jobs.
    </v-card-subtitle>
    <v-card-text v-if="expanded">
      <p>{{ text }}</p>
      <DateRangeSelect
        v-if="!noDates"
        :from.sync="dateFrom"
        :to.sync="dateTo"
      />
      <v-btn
        depressed
        tile
        color="primary"
        class="mt-2"
        :disabled="(dateFrom === null || dateTo === null) && !noDates"
        @click="generateReport"
      >
        Generate Report
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script>
import DateRangeSelect from './DateRangeSelect.vue'

export default {
  components: { DateRangeSelect },
  props: {
    title: { type: String, default: null },
    text: { type: String, default: null },
    noDates: { type: Boolean, default: false }
  },
  data() {
    return {
      expanded: true,
      dateFrom: null,
      dateTo: null
    }
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded
    },
    generateReport() {
      this.$emit('generate', { from: this.dateFrom, to: this.dateTo })
    }
  }
}
</script>
